import React from 'react';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import ChipList from './ChipList';
var useStyles = makeStyles(function () {
    return {
        root: {
            padding: '14px 16px',
            borderBottom: 'thin solid #E0E0E0'
        },
        chip: {
            marginRight: '4px',
            marginBottom: '4px'
        },
        emailOnly: {
            fontSize: '14px',
            fontWeight: 300
        },
        userName: {
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '18.2px',
            color: '#191919'
        },
        userEmail: {
            fontSize: '12px',
            fontWeight: 400,
            lineHeight: '15px',
            color: '#646464',
            marginTop: '4px'
        }
    };
});
export function UserRow(_a) {
    var _b;
    var user = _a.user;
    var classes = useStyles();
    return (React.createElement(Grid, { container: true, item: true, xs: 12, className: classes.root },
        React.createElement(Grid, { item: true, xs: 6 }, user.firstName && user.lastName ? (React.createElement(React.Fragment, null,
            React.createElement(Typography, { variant: "body1", className: classes.userName }, "".concat(user.firstName, " ").concat(user.lastName)),
            React.createElement(Typography, { variant: "body2", className: classes.userEmail }, user.email))) : (React.createElement(React.Fragment, null,
            React.createElement(Typography, { className: classes.emailOnly, variant: "body1" }, user.email)))),
        React.createElement(Grid, { item: true, xs: 6 }, ((_b = user.licenses) === null || _b === void 0 ? void 0 : _b.length) ? React.createElement(ChipList, { licenses: user.licenses, truncateAt: 2 }) : null)));
}
export function LoadingUserRow() {
    var classes = useStyles();
    return (React.createElement(Grid, { container: true, item: true, xs: 12, className: classes.root },
        React.createElement(Grid, { item: true, xs: 6 },
            React.createElement(Skeleton, { width: "100px" }),
            React.createElement(Skeleton, { width: "150px" })),
        React.createElement(Grid, { item: true, xs: 6 },
            React.createElement(Skeleton, { width: "150px" }))));
}
//# sourceMappingURL=UserRow.js.map